export default __webpack_public_path__ + "static/rovo-thinking-skeleton-light-ba249e9bdec351a0b436fe7c1476d21ebe9a6fcaafd30ed611e9e2836e0f3181.png";